import { ALLOCATION_DIMENSION } from "constants/action-types";
import type {
    IAllocationDimension,
    AllocationDimensionOwnerObject,
    ICreateAllocationDimension,
    IUpdateAllocationDimension,
} from "helpers/allocation-dimension";
import { FluxStandardAction as Action } from "flux-standard-action";

export type ListAllocationDimensionRequestAction = Action<
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    },
    undefined
>;
export const listAllocationDimensionRequest = (
    objectId: string,
    owner: AllocationDimensionOwnerObject
): ListAllocationDimensionRequestAction => ({
    meta: undefined,
    payload: { objectId, owner },
    type: ALLOCATION_DIMENSION.LIST.REQUEST,
});

export type ListAllocationDimensionCompleteAction = Action<IAllocationDimension[] | Error, undefined>;
export const listAllocationDimensionComplete = (
    payload: IAllocationDimension[] | Error
): ListAllocationDimensionCompleteAction => ({
    meta: undefined,
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.LIST.COMPLETE,
});

export type GetAllocationDimensionRequestAction = Action<
    string,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const getAllocationDimensionRequest = (
    allocationDimensionId: string,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): GetAllocationDimensionRequestAction => ({
    meta: { objectId, owner },
    payload: allocationDimensionId,
    type: ALLOCATION_DIMENSION.GET.REQUEST,
});

export type GetAllocationDimensionCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const getAllocationDimensionComplete = (
    payload: IAllocationDimension | Error,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): GetAllocationDimensionCompleteAction => ({
    meta: { objectId, owner },
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.GET.COMPLETE,
});

export type CreateAllocationDimensionRequestAction = Action<
    {
        allocationDimension: ICreateAllocationDimension;
    },
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
        merchantV0Uuid: string;
    }
>;
export const createAllocationDimensionRequest = (
    allocationDimension: ICreateAllocationDimension,
    objectId: string,
    owner: AllocationDimensionOwnerObject,
    merchantV0Uuid: string
): CreateAllocationDimensionRequestAction => ({
    meta: { objectId, owner, merchantV0Uuid },
    payload: {
        allocationDimension,
    },
    type: ALLOCATION_DIMENSION.CREATE.REQUEST,
});

export type CreateAllocationDimensionCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
        merchantV0Uuid: string;
    }
>;
export const createAllocationDimensionComplete = (
    payload: IAllocationDimension | Error,
    objectId: string,
    owner: AllocationDimensionOwnerObject,
    merchantV0Uuid: string
): CreateAllocationDimensionCompleteAction => ({
    meta: { objectId, owner, merchantV0Uuid },
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.CREATE.COMPLETE,
});

export type UpdateAllocationDimensionRequestAction = Action<
    {
        allocationDimensionId: string;
        allocationDimension: IUpdateAllocationDimension;
    },
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const updateAllocationDimensionRequest = (
    allocationDimensionId: string,
    allocationDimension: IUpdateAllocationDimension,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): UpdateAllocationDimensionRequestAction => ({
    meta: { objectId, owner },
    payload: { allocationDimension, allocationDimensionId },
    type: ALLOCATION_DIMENSION.UPDATE.REQUEST,
});

export type UpdateAllocationDimensionCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    }
>;
export const updateAllocationDimensionComplete = (
    payload: IAllocationDimension | Error,
    objectId: string,
    owner: AllocationDimensionOwnerObject
): UpdateAllocationDimensionCompleteAction => ({
    meta: { objectId, owner },
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.UPDATE.COMPLETE,
});
